export default "__VITE_ASSET__CtBenGPj__"